import React from "react";
import RteField from "../atom/RteField";

function CareerFormDescription({ data = {}, onChange, errors = {} }) {
  const handleChange = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  // Removed max-h and inner overflow so the page can scroll naturally
  return (
    <form className="grid grid-cols-1 gap-6">
      <RteField
        label="About MTN"
        value={data.about || ""}
        onChange={(html) => handleChange("about", html)}
        placeholder="Describe MTN, culture, benefits..."
        error={errors.aboutMtn}
      />

      <RteField
        label="Mission/Core purpose of The Job"
        value={data.mission || ""}
        onChange={(html) => handleChange("mission", html)}
        placeholder="State the mission for this role"
        error={errors.mission}
      />

      <RteField
        label="Key Performance Area"
        value={data.kpa || ""}
        onChange={(html) => handleChange("kpa", html)}
        placeholder="List the KPAs for the role"
        error={errors.keyPerformanceAreas}
      />

      <RteField
        label="How To Apply"
        value={data.applyInstructions || ""}
        onChange={(html) => handleChange("applyInstructions", html)}
        placeholder="Provide application steps, email, and deadline notes"
        error={errors.applyInstructions}
      />
    </form>
  );
}

export default CareerFormDescription;
